<template>
  <div class="section-wrapper">
    <div class="sec4-trigger"></div>
    <div class="temporary-bg"></div>
    <div class="left-side sec-4-left-side">
      <div class="left-side-inner">
        
        <h2>AGD po ludzku</h2>
        <div class="left-side-copy-n-nav">
          <p>W ramach akcji 'Zaprojektowane po ludzku' chcemy promować i nagradzać tych, którzy projektują pamiętając o ludzkich potrzebach.</p>
          <div class="left-side-nav">
            <a @click.prevent="previousSlide()" class="carousel-nav carousel-nav--left" href=""></a>
            <a @click.prevent="nextSlide()" class="carousel-nav carousel-nav--right" href=""></a>
          </div>
        </div>

        <div class="left-side-posts">
          
          <div class="single-post">
            <img :src="`${postData(countPointer())['image']}`" alt="" />
            <h4>{{ postData(countPointer())['title'] }}</h4>
            <p>{{ postData(countPointer())['content'] }}</p>
            <a :href="postData(countPointer())['url']" target="_blank" rel="noopener noreferrer">Przeczytaj artykuł</a>
          </div>

          <div class="single-post">
            <img :src="`${postData(countPointer(1))['image']}`" alt="" />
            <h4>{{ postData(countPointer(1))['title'] }}</h4>
            <p>{{ postData(countPointer(1))['content'] }}</p>
            <a :href="postData(countPointer(1))['url']" target="_blank" rel="noopener noreferrer">Przeczytaj artykuł</a>
          </div>

        </div>
        
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return  {
      currentPostPointer: 0,
    }
  },
  computed: {
    posts: function () {
      return window.pageContentData.params.posts
    }
  },
  methods: {
    previousSlide: function () {
      if (this.currentPostPointer == 0) {
        this.currentPostPointer = this.posts.length - 1
      } else {
        this.currentPostPointer -= 1
      }
    },
    nextSlide: function () {
      if (this.currentPostPointer === this.posts.length - 1) {
        this.currentPostPointer = 0
      } else {
        this.currentPostPointer += 1
      }
    },
    countPointer: function (positionMod = 0) { // positionMod = 0 || 1
      if (positionMod === 1) {
        return this.currentPostPointer + 1 > this.posts.length - 1 ? 0 : this.currentPostPointer + 1;
      }
      return this.currentPostPointer
    },
    postData: function (pointer) {
      return this.posts[pointer]
    }
  },
  mounted () {
    if (window.innerWidth > 1024) {
      const scene000 = this.$scrollmagic.scene({
        triggerElement: '.sec8-trigger',
        triggerHook: .8,
        duration: '40%',
        // reverse: true,
      })

      let Timeline000 = new TimelineMax();


      let womanMoveTweeen = TweenMax.to('.woman-bg, .woman-big-dot, .woman-heart-cnt, .dots-cnt', 1, {
        // autoAlpha: 0.1,
        // yPercent: 100,
        xPercent: 27
      })

      let opacityTween = TweenMax.to('.woman-big-dot, .dots-cnt', 1, {
        autoAlpha: 0.1,
        // yPercent: 100,
        // xPercent: 27
      })

      Timeline000
        .add(womanMoveTweeen)
        .add(opacityTween)

      this.$scrollmagic.addScene(
        scene000
          .setTween(Timeline000)
          // .addIndicators()
      )

      const scene1 = this.$scrollmagic.scene({
        triggerElement: '.sec8-trigger',
        triggerHook: .1,
        duration: '100%',
      })

      scene1.setPin('.sec-4-left-side')

      this.$scrollmagic.addScene(
        scene1
          // .addIndicators()
      )
    }
    
  },
}
</script>

<style lang="scss" scoped>
  .section-wrapper {
    width: 100%;
    min-height: calc(100vh - 70px);
    height: auto;
    padding: 15vw 0;
    position: relative;
    display: flex;

    @media only screen and (max-width : 1024px) {
      min-height: auto;
      height: auto;
      padding: 4rem 0;
    }

    @media only screen and (max-width : 768px) {
      flex-direction: column;
      padding: 2rem 0;
    }

    .temporary-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px; 
      background: #fff url('../../../assets/images/zpl/bg-sec-4.jpg');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 50% 100%;
      z-index: 0;
      pointer-events: none;
      display: none;

      @media only screen and (max-width : 1024px) {
        opacity: .08;
        display: block;
      }

      @media only screen and (max-width : 768px) {
        display: none;
      }
    }

    .left-side {
      // height: 100%;
      width: 100%;
      position: relative;

      .left-side-inner {
        padding-left: 8.3333vw;
        height: 100%;
        width: calc(57.5% - 8.3333vw);
        box-sizing: content-box;
        display: flex;
        flex-direction: column;
        justify-content: center;

        @media only screen and (max-width : 1024px) {
          width: calc(100% - 8.33% - 8.33%);
          padding-left: 8.33%;
          padding-right: 8.33%;
        }

        h2 {
          color: #e41429;
          font-size: 3.2rem;
          margin-bottom: 2rem;
          font-weight: 600;
          margin-top: auto;

          @media only screen and (max-width : 1024px) {
            font-size: 2.2rem;
          }
        }

        .left-side-copy-n-nav {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-bottom: 3rem;

          p {
            display: inline-block;
            width: 65%;
          }

          .left-side-nav {
            display: flex;
            flex-direction: row;
            align-items: center;

            a.carousel-nav {
              width: 40px;
              height: 40px;
              display: inline-block;
              border: 2px rgb(181, 181, 181) solid;
              border-radius: 99px;
              margin-left: 1rem;
              position: relative;

              -webkit-transition: all .2s ease-in-out;
              -moz-transition: all .2s ease-in-out;
              -o-transition: all .2s ease-in-out;
              transition: all .2s ease-in-out;

              &:before {
                content: "";
                width: 10px;
                height: 2px;
                position: absolute;
                top: calc(50% + 2px);
                left: calc(50% - 6px);
                background: #e41429;

                transform: rotate(45deg);
              }

              &:after {
                content: "";
                width: 10px;
                height: 2px;
                position: absolute;
                top: calc(50% - 4px);
                left: calc(50% - 6px);
                background: #e41429;

                transform: rotate(-45deg);
              }

              &.carousel-nav--right {
                transform: rotate(180deg);
              }

              &:hover {
                background: rgba(181, 181, 181, .2);
              }
            }

            span.carousel-nav-numeric {
              display: inline-block;
              margin-left: 1.5rem;
            }
          }
        }

        .left-side-posts {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-bottom: auto;

          .single-post {
            width: 49%;

            img {
              width: 100%;
              max-width: 100%;
              margin-bottom: 1rem;
            }

            h4 {
              margin-bottom: 1rem;
              line-height: 1.6rem;
              min-height: calc(1.6rem * 2);
              font-weight: 600;

              @media only screen and (max-width : 768px) {
                min-height: calc(1.6rem * 3);
              }
            }

            p {
              font-size: 1rem;
              line-height: 1.6rem;
              max-height: calc(1.6rem * 3);
              overflow: hidden;
            }

            a {
              color: #e41429;
              text-transform: uppercase;
              align-self: flex-end;
              position: relative;
              margin-right: 20px;
              margin-top: 1.5rem;

              &:after {
                content: "";
                position: absolute;
                top: 7px;
                right: -15px;
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 4px 0 4px 5px;
                border-color: transparent transparent transparent #e42429;
              }

              &:hover {
                text-decoration: none;
                color: darken(#e41428, 10%);
              }
            }
          }
        }
        
      }
    }

  }
</style>